import { UserOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form, Input, Typography } from 'antd';
import React, { useState } from 'react';

import REQUEST_PASSWORD_RESET from '../../apollo/auth/mutations/requestPasswordReset';
import ResetCodeSent from '../../components/Auth/ResetCodeSent';
import { ErrorLogger } from '../../utils/ErrorLogger';
import { messages, MessageTypes } from './messages';

const { Title } = Typography;

export interface ForgotForm {
  email: string;
}

const ForgotPassword: React.FC = () => {
  const [complete, setComplete] = useState(false);
  const [requestPasswordReset, { loading }] = useMutation(
    REQUEST_PASSWORD_RESET
  );

  const onFinish = async ({ email }: ForgotForm) => {
    try {
      await requestPasswordReset({ variables: { email } });
      setComplete(true);
    } catch (err) {
      setComplete(false);
      ErrorLogger.logError(err);
    }
  };

  if (complete) {
    return <ResetCodeSent />;
  }

  return (
    <Form
      className="app__form app__form--auto app__form--center app__form--space-between"
      onFinish={onFinish}
    >
      <Form.Item>
        <Title level={4}>Enter your Email Address</Title>
      </Form.Item>
      <Form.Item
        name="email"
        rules={[
          {
            type: 'email',
            required: true,
            message: messages[MessageTypes.WrongEmail],
          },
        ]}
      >
        <Input
          size="large"
          prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder="Email"
          type="email"
        />
      </Form.Item>

      <Form.Item>
        <Button
          size="large"
          type="primary"
          htmlType="submit"
          className="login-form-button"
          loading={loading}
        >
          Reset your password
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ForgotPassword;
